module.exports = __webpack_public_path__ + "img/img-10.139b298b.jpg";